import React, { PureComponent } from "react";
import { Tree as AntTree } from "antd";
const { TreeNode } = AntTree;

export default class Tree extends PureComponent {
  constructor() {
    super();
    this.state = {
      fileList: []
    };
  }
  onCheck = checkedKeys => {
    const { onChange } = this.props;
    onChange(checkedKeys.filter(item => item.indexOf("-") < 0));
  };
  renderTreeNodes = data =>
    data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode {...item} />;
    });
  render() {
    const { value, field, options = [], fields, opts = {} } = this.props;
    return (
      <AntTree
        checkable
        disabled={fields.show_detail}
        onCheck={this.onCheck}
        checkedKeys={value}
        {...opts}
      >
        {this.renderTreeNodes(options[field] || [])}
      </AntTree>
    );
  }
}
